module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("This book is dedicated to my precious son, Nathan, my wonderful daughters, Denay and Alisha, my two outstanding sons-in-law, Heighlos and Tim, and my two unbelievably adorable grandchildren, Soel and Sage.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Shelley and I love all of you more than words could possibly convey")])])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7eade28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006dedication.vue
// module id = 72
// module chunks = 0